export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'subscription' | 'payment';
  price: {
    monthly?: number;
    annual?: number;
    oneTime?: number;
  };
}

export const stripeProducts: StripeProduct[] = [
  {
    id: 'prod_SaUJjfS2xZgmQJ',
    priceId: 'price_1RfJKYRss688mKzQfKDtaiYM',
    name: 'Enki Premium Plan',
    description: 'Subscription for Enki Premium Plan',
    mode: 'subscription',
    price: {
      monthly: 10,
    },
  },
  {
    id: 'prod_SaUJQ0dr2JPe7H',
    priceId: 'price_1RfJL2Rss688mKzQrGT3GoFq',
    name: 'Enki Unilimited',
    description: 'Subcription for Enki Unilimited',
    mode: 'subscription',
    price: {
      monthly: 25,
    },
  },
];

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.priceId === priceId);
};

export const getProductById = (productId: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.id === productId);
};